import React, { useMemo, useState} from "react";
import withName from "../../hoc/withName";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes} from "@fortawesome/free-solid-svg-icons";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Tooltip } from "primereact/tooltip";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import MultiSelectPrime from "../PrimeComponents/MultiSelectPrime";
import { Message } from "primereact/message";
import { CONTRATO_ANUAL, CONTRATO_MENSUAL, CONTRATO_SEMESTRAL, CONTRATO_TRIMESTAL } from "../../utils/BillingUtils";
const PriceListDiscounts = ({formik}) => {

    const { t } = useTranslation();
    const [showMsg,setShowMsg] = useState(false);
    const billingPeriods = [
        {"label":t("billing.policyPage.periods."+CONTRATO_MENSUAL), "id":CONTRATO_MENSUAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_TRIMESTAL), "id":CONTRATO_TRIMESTAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_SEMESTRAL), "id":CONTRATO_SEMESTRAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_ANUAL), "id":CONTRATO_ANUAL}];
    const names = useMemo(() => [
        <>
            <Tooltip target="#title-rangeMin" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.rangeMin")}
                data-pr-position="top"
                id="title-rangeMin"
            >{t("billing.discounts.rangeMin")}
            </div>
        </>,
        <>
            <Tooltip target="#title-rangeMax" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.rangeMax")}
                data-pr-position="top"
                id="title-rangeMax"
            >{t("billing.discounts.rangeMax")}
            </div>
        </>,
        <>
            <Tooltip target="#title-discount" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.discount")}
                data-pr-position="top"
                id="title-discount"
            >{t("billing.discounts.discount")}
            </div>
        </>,
        <>
            <Tooltip target="#title-includedUser" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.includedUser")}
                data-pr-position="top"
                id="title-includedUser"
            >{t("billing.discounts.includedUser")}
            </div>
        </>,
        <>
            <Tooltip target="#title-includedAPI" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.includedAPI")}
                data-pr-position="top"
                id="title-includedAPI"
            >{t("billing.discounts.includedAPI")}
            </div>
        </>,
        <>
            <Tooltip target="#title-sms" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.SMS")}
                data-pr-position="top"
                id="title-sms"
            >{t("billing.sms")}
            </div>
        </>,
        <>
            <Tooltip target="#title-calls" className='wTt' />
            <div
                data-pr-tooltip={t("selfHelp.priceList.properties.calls")}
                data-pr-position="top"
                id="title-calls"
            >{t("billing.calls")}
            </div>
        </>
    ], [t]);
    const addRow = () => {
        const lastRange = formik?.values?.config_descuentos[formik?.values.config_descuentos?.length-1??0];
        const newRow = {
            discount: null,
            includedUser: null,
            includedAPI: null,
            SMS: null,
            calls: null,
        };
        if(lastRange) {
            const amplitude = lastRange.rangeMax-lastRange.rangeMin;
            newRow.rangeMin = lastRange.rangeMax+1;
            newRow.rangeMax = lastRange.rangeMax+1+amplitude;
        }else{
            newRow.rangeMin = 0;
            newRow.rangeMax = 5;
        }
        formik.values.config_descuentos.push(newRow);
        formik.setFieldValue("config_descuentos",formik.values.config_descuentos);
    };

    const deleteRowTemplate = (rowData) => {
        const index = formik?.values?.config_descuentos.findIndex(e => e.rangeMin === rowData.rangeMin);
        return (
            <FontAwesomeIcon className='btnEdit pointer' size="lg" style={{ color: "red" }}
                icon={faTimes} onClick={() => {
                    formik?.values?.config_descuentos.splice(index, 1);
                    formik.setFieldValue("config_descuentos",formik.values.config_descuentos);
                }}
            >
                {t("forms.delete")}
            </FontAwesomeIcon>
        );
    };
    const onRowEditComplete = (e) => {
        const _discounts = [...(formik?.values?.config_descuentos ?? [])];
        const { newData, index } = e;
        if(newData.rangeMax < newData.rangeMin){
            newData.rangeMax = newData.rangeMin + (_discounts[0].rangeMax - _discounts[0].rangeMin);
        }
        if(newData.discount >100 ){
            newData.discount = 100;
        }
        _discounts[index] = newData;
        for (let i = index; i < _discounts.length; i++) {
            const amplitude = _discounts[i].rangeMax - _discounts[i].rangeMin;
            if(i >0){
                _discounts[i].rangeMin = _discounts[i-1].rangeMax+1;
                _discounts[i].rangeMax = _discounts[i].rangeMin + amplitude;
            }
        }
        formik.setFieldValue("config_descuentos",_discounts);
    };
    const textEditor = (options) => {
        if(options.field ==="discount"){
            return <InputNumber min={0} max={100} className="innerSmallInput" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
        }
        else if(options.field ==="rangeMin" && options.rowIndex === 0){
            return <InputNumber min={0} className="innerSmallInput" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
        }
        else if(options.field ==="rangeMin"){
            return <InputNumber disabled className="innerSmallInput" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
        }
        else if(options.field ==="rangeMax"){
            return <InputNumber min={options.rowData.rangeMin +1} className="innerSmallInput" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
        }
        else{
            return <InputNumber min={0} className="innerSmallInput" value={options.value} onChange={(e) => options.editorCallback(e.value)} />;
        }
    };

    const msgContent = (
        <div className="d-flex align-items-center" style={{width:"100%" }}>
            <i className="pi pi-info-circle" style={{ fontSize: "2rem", color:"#01579B" }} />
            <div className="ml-2" style={{ fontSize: "14px"}}>
                {t("billing.applyPeriodsContent")}
            </div>
            <span className='ml-3' data-testid="hide_billing_discount_span" onClick={() => {
                setShowMsg(false);
            }} style={{ cursor: "pointer" }}
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.98128 8.00888L13.1104 3.87975C13.1793 3.81561 13.2345 3.73825 13.2728 3.65231C13.3111 3.56636 13.3316 3.47359 13.3333 3.37951C13.335 3.28543 13.3177 3.19199 13.2824 3.10474C13.2472 3.0175 13.1947 2.93825 13.1282 2.87172C13.0617 2.80519 12.9824 2.75274 12.8952 2.7175C12.8079 2.68226 12.7145 2.66495 12.6204 2.66661C12.5263 2.66827 12.4336 2.68886 12.3476 2.72716C12.2617 2.76545 12.1843 2.82067 12.1202 2.8895L7.99103 7.01864L3.8619 2.8895C3.72908 2.76574 3.55341 2.69836 3.37189 2.70157C3.19038 2.70477 3.01719 2.7783 2.88882 2.90667C2.76045 3.03504 2.68692 3.20823 2.68372 3.38974C2.68051 3.57126 2.74789 3.74693 2.87165 3.87975L7.00079 8.00888L2.87165 12.138C2.74045 12.2694 2.66675 12.4475 2.66675 12.6331C2.66675 12.8188 2.74045 12.9969 2.87165 13.1283C3.00303 13.2595 3.18111 13.3332 3.36678 13.3332C3.55245 13.3332 3.73053 13.2595 3.8619 13.1283L7.99103 8.99913L12.1202 13.1283C12.2515 13.2595 12.4296 13.3332 12.6153 13.3332C12.801 13.3332 12.979 13.2595 13.1104 13.1283C13.2416 12.9969 13.3153 12.8188 13.3153 12.6331C13.3153 12.4475 13.2416 12.2694 13.1104 12.138L8.98128 8.00888Z" fill="#01579B" />
                </svg>
            </span>
        </div>
    );
    return (
        <div className='col-xl-6 col-lg-12 col-sm-12'>
            <div className='card'>
                <div className="card-body">
                    <div className='row'>
                        <div className='col col-sm-11 col-md-11 col-lg-11 text-center'>
                            <h5 className="card-title"><span>{t("billing.priceListPage.discounts")}</span></h5>
                        </div>
                        <div className='col col-sm-1 col-md-1 col-lg-1 d-flex justify-content-end align-items-center' />
                    </div>
                    <div className='linea-titulo' />
                    <div className="row linea-formulario">
                        <div className="col-12 text-center">
                            <DataTable
                                value={formik?.values?.config_descuentos} editMode="row" dataKey="rangeMin"
                                onRowEditComplete={onRowEditComplete} tableStyle={{ width: "100%" }}
                                rowClassName="bodyPrimeTable" emptyMessage={t("billing.noDiscounts")}
                            >
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="rangeMin" header={names[0]} editor={(options) => textEditor(options)} style={{ width: "2%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="rangeMax" header={names[1]} editor={(options) => textEditor(options)} style={{ width: "2%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="discount" header={names[2]} editor={(options) => textEditor(options)} style={{ width: "5%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="includedUser" header={names[3]} editor={(options) => textEditor(options)} style={{ width: "3%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="includedAPI" header={names[4]} editor={(options) => textEditor(options)} style={{ width: "2%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="SMS" header={names[5]} editor={(options) => textEditor(options)} style={{ width: "2%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="calls" header={names[6]} editor={(options) => textEditor(options)} style={{ width: "4%" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" rowEditor headerStyle={{ width: "3%" }} bodyStyle={{ textAlign: "center" }} />
                                <Column className="centerAlignTD fontSmall" headerClassName="headerPrimeTable fontSmall" field="code" body={deleteRowTemplate}style={{ width: "2%" }} />
                            </DataTable>
                        </div>
                        {
                            formik?.errors?.config_descuentos?
                                <div className="col-12 text-center">
                                    <small className="p-error text-danger">{t("billing.formValidation.discount")}</small>
                                </div>
                                :null
                        }
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-12 text-center pb-2">
                            <ButtonPrime onClick={addRow} label={t("billing.addRange")} />
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-3 col-lg-12 col-sm-12 text-sm-right mtem-05">
                            <label className="boldie">{t("billing.applyPeriods")}</label>
                        </div>
                        <div className="col-xl-9 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            <MultiSelectPrime
                                value={formik?.values?.periodos?.map(p1 => billingPeriods.find(bp=>bp.id===p1))}
                                onChange={(e) => {
                                    if(e.value.length===0){
                                        formik.setFieldValue("periodos",[CONTRATO_MENSUAL, CONTRATO_TRIMESTAL, CONTRATO_SEMESTRAL, CONTRATO_ANUAL]);
                                        setShowMsg(true);
                                    }else{
                                        formik.setFieldValue("periodos",e?.value.map(v => v.id));
                                    }
                                }}
                                options={billingPeriods}
                                optionLabel="label"
                                optionValue="id"
                                placeholder={t("forms.pHolderSelect")}
                                maxSelectedLabels={0}
                                display="chip"
                                smallChips
                                filter={null}
                                showClear={false}
                                showSelectAll={false}
                            />
                        </div>
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-sm-left mtem-05">
                            {showMsg?<Message severity="info" content={msgContent}
                                style={{
                                    border: "solid #01579B",
                                    borderWidth: "0 0 0 6px",
                                    color: "#696cff"
                                }}
                            />:null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(PriceListDiscounts, "PriceListDiscounts");
